import { gql } from '@apollo/client';

// Operation name `StudentGroupAttendance` is deliberately distinct from the
// backend field `myAttendance` — equal operation/field names make codegen
// collapse the generated result type into the schema payload type
// (graphql-codegen skill).
//
// Self-scoped on the server: there is no student argument, the rows come from
// the token. `attendance` is nullable on purpose — null means the teacher has
// not filled the journal for that lesson yet, which is NOT an absence.
export const StudentGroupAttendanceQuery = gql`
  query StudentGroupAttendance($groupId: ID!) {
    myAttendance(groupId: $groupId) {
      lessonId
      lessonName
      lessonNumber
      date
      attendance
      # ВНИМАНИЕ: не добавлять сюда source и markedAt, пока backend-часть
      # ТЗ 0026 не выложена на прод. Эти поля есть в локальном main, но на
      # erp-api.learnit.com.pl их нет, а неизвестное поле — это ошибка
      # ВАЛИДАЦИИ: прод отвечает HTTP 400, глобальный errorLink в
      # core/graphql/client/client.ts превращает любой код кроме 500/503/404 в
      # NetworkErrors.otherError, и у студента перестаёт открываться ЛЮБАЯ
      # группа — страница курса гасится целиком, lessonForLms даже не успевает
      # ответить. Возвращать вместе с деплоем бэкенда, см. коммит 17684a8.
    }
  }
`;
